import React from 'react';

export const Menu = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_181_51907"
      className="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="21"
    >
      <rect x="0.852051" y="0.849487" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_181_51907)">
      <path
        d="M4.55693 17.2254C3.97003 17.2254 3.49426 16.7496 3.49426 16.1627C3.49426 15.5759 3.97003 15.1001 4.55693 15.1001H17.1464C17.7333 15.1001 18.2091 15.5759 18.2091 16.1627C18.2091 16.7496 17.7333 17.2254 17.1464 17.2254H4.55693ZM4.55693 11.9121C3.97003 11.9121 3.49426 11.4363 3.49426 10.8494C3.49426 10.2625 3.97003 9.78677 4.55693 9.78677H17.1464C17.7333 9.78677 18.2091 10.2625 18.2091 10.8494C18.2091 11.4363 17.7333 11.9121 17.1464 11.9121H4.55693ZM4.55693 6.59878C3.97003 6.59878 3.49426 6.12301 3.49426 5.53611C3.49426 4.94922 3.97003 4.47345 4.55693 4.47345H17.1464C17.7333 4.47345 18.2091 4.94922 18.2091 5.53611C18.2091 6.12301 17.7333 6.59878 17.1464 6.59878H4.55693Z"
        fill="#7D7A9A"
      />
    </g>
  </svg>
);
